module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="middle">\r\n    <nav class="nav">\r\n        <div class="nav-imgbox f-fl f-cl">\r\n            <img  class="nav-tit" src="' +
((__t = ( img[0] )) == null ? '' : __t) +
'" alt="">\r\n        </div>\r\n        <span class="nav-phone f-ft_sub f-fr f-cr">客服热线：' +
((__t = ( phone )) == null ? '' : __t) +
'</span>\r\n    </nav>\r\n    <header class="banner g-pr">\r\n        <img class="image-w" src="' +
((__t = ( img[2] )) == null ? '' : __t) +
'" alt="">\r\n    </header>\r\n    <section class="part0">\r\n        <img class="image-w" src="' +
((__t = ( img[11] )) == null ? '' : __t) +
'" alt="">\r\n    </section>\r\n    <section class="part3">\r\n        <img class="image-w" src="' +
((__t = ( img[5] )) == null ? '' : __t) +
'" alt="">\r\n    </section>\r\n</section>';

}
return __p
}